import { apiClient } from '@/api/api'

export interface UploadedImage {
  /** S3 key, not a URL — the wardrobe upload takes it verbatim (§5.1). */
  img_url: string
}

/**
 * Wardrobe photo → S3 key in the `user_wardrobe` bucket. The route is
 * excluded from the case transformer, so the key stays `img_url`.
 */
export const uploadWardrobeImage = async (image: File | Blob) => {
  return apiClient.postForm<UploadedImage>(
    '/images/upload_img',
    { img: image },
    { params: { uploaded_from: 'user-wardrobe' } },
  )
}
